import { createColumnHelper } from '@tanstack/react-table';

import { RowItem } from '../../types';

const columnHelper = createColumnHelper<RowItem>();

export default columnHelper;
